import { render, staticRenderFns } from "./erpGoods.vue?vue&type=template&id=92ea3220&scoped=true"
import script from "./erpGoods.vue?vue&type=script&lang=js"
export * from "./erpGoods.vue?vue&type=script&lang=js"
import style0 from "./erpGoods.vue?vue&type=style&index=0&id=92ea3220&lang=less"
import style1 from "./erpGoods.vue?vue&type=style&index=1&id=92ea3220&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ea3220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92ea3220')) {
      api.createRecord('92ea3220', component.options)
    } else {
      api.reload('92ea3220', component.options)
    }
    module.hot.accept("./erpGoods.vue?vue&type=template&id=92ea3220&scoped=true", function () {
      api.rerender('92ea3220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/customer/erpGoods.vue"
export default component.exports